import React from 'react'

interface FeaturedProjectVideoBackgroundProps {
  backgroundVideo: string
}

export const FeaturedProjectVideoBackground: React.FC<FeaturedProjectVideoBackgroundProps> = ({ backgroundVideo }) => {
  return (
    <>
      <video
        className="absolute left-1/2 top-1/2 h-full min-w-full -translate-x-1/2 -translate-y-1/2 bg-cover object-cover"
        autoPlay
        playsInline
        muted
        loop
        src={backgroundVideo}
      />
    </>
  )
}
